import React from 'react';
import { Button } from '../../../components/base/Button';

export const ContactSection: React.FC = () => {
  const handleWhatsAppClick = () => {
    // Rastreamento Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'Contact', {
        content_name: 'WhatsApp Orçamento',
        content_category: 'Button Click'
      });
    }
    
    window.open('https://wa.me/5585987894357?text=Olá! Gostaria de solicitar um orçamento para estamparia digital.', '_blank');
  };

  return (
    <section id="contato" className="py-16 md:py-20 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 lg:mb-20">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6 px-2">Fale Conosco</h3>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4 leading-relaxed">
              Entre em contato conosco via WhatsApp e solicite seu orçamento. Nossa equipe está pronta 
              para atender suas necessidades em <strong>estamparia digital têxtil</strong>.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12">
            {/* WhatsApp CTA - Destaque Principal */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl md:rounded-3xl p-8 sm:p-10 md:p-12 border-2 border-green-200 shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-center">
                <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8 shadow-lg">
                  <i className="ri-whatsapp-fill text-4xl sm:text-5xl md:text-6xl text-white"></i>
                </div>
                <h4 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">Atendimento Direto via WhatsApp</h4>
                <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-8 md:mb-10 leading-relaxed">
                  Fale diretamente com nossa equipe de atendimento especializado. 
                  Tire suas dúvidas e solicite seu orçamento de forma rápida e prática!
                </p>
                <Button 
                  onClick={handleWhatsAppClick}
                  size="lg"
                  icon="ri-whatsapp-fill"
                  className="bg-green-500 hover:bg-green-600 w-full text-sm sm:text-base md:text-lg py-4 md:py-5 justify-center shadow-xl hover:scale-105 transform transition-transform"
                >
                  Solicitar Orçamento
                </Button>
                <p className="text-sm sm:text-base text-gray-500 mt-5 md:mt-6 font-medium">
                  Resposta rápida • Atendimento personalizado
                </p>
              </div>
            </div>
            
            {/* Contact Info */}
            <div className="space-y-6 md:space-y-8">
              {/* Contact Details */}
              <div className="bg-gray-50 rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg">
                <h4 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-6 md:mb-8">Informações de Contato</h4>
                <div className="space-y-5 md:space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-purple-100 rounded-xl flex items-center justify-center mr-4 md:mr-5 flex-shrink-0">
                      <i className="ri-map-pin-fill text-purple-600 text-xl sm:text-2xl md:text-3xl"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-gray-900 text-base sm:text-lg md:text-xl mb-1">Endereço</p>
                      <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed">Rua Senador Pompeu 2379, Fortaleza, CE</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-purple-100 rounded-xl flex items-center justify-center mr-4 md:mr-5 flex-shrink-0">
                      <i className="ri-phone-fill text-purple-600 text-xl sm:text-2xl md:text-3xl"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-gray-900 text-base sm:text-lg md:text-xl mb-1">Telefone</p>
                      <p className="text-sm sm:text-base md:text-lg text-gray-600">(85) 8765-5550</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-purple-100 rounded-xl flex items-center justify-center mr-4 md:mr-5 flex-shrink-0">
                      <i className="ri-mail-fill text-purple-600 text-xl sm:text-2xl md:text-3xl"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-gray-900 text-base sm:text-lg md:text-xl mb-1">E-mail</p>
                      <p className="text-sm sm:text-base md:text-lg text-gray-600 break-all">gmxdigital.adm@gmail.com</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-purple-100 rounded-xl flex items-center justify-center mr-4 md:mr-5 flex-shrink-0">
                      <i className="ri-time-fill text-purple-600 text-xl sm:text-2xl md:text-3xl"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-gray-900 text-base sm:text-lg md:text-xl mb-1">Horário</p>
                      <p className="text-sm sm:text-base md:text-lg text-gray-600">Seg-Sex: 8h às 17h</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Map */}
              <div className="bg-gray-50 rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg">
                <h4 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6">Nossa Localização</h4>
                <div className="aspect-video rounded-xl md:rounded-2xl overflow-hidden shadow-md">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.2345!2d-38.5267!3d-3.7319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c7479c0c7d3f11%3A0x7d3f8b8b8b8b8b8b!2sRua%20Senador%20Pompeu%2C%202379%2C%20Fortaleza%20-%20CE!5e0!3m2!1spt!2sbr!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Localização GMX Fortaleza"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
